<template>
  <page-skeleton>
    <template slot="header-left">
      <el-button size="medium" type="primary" round @click="addMaterial">添加材质</el-button>
    </template>

    <template slot="container">
      <el-table :data="tableData" ref="multipleTable" style="width: 100%" height="100%">
        <el-table-column v-for="(item, index) in (tableData[0] && tableData[0].list)" :key="item.languageId">
          <template slot="header">
            {{item.name  === '通用英语' ? '材质名称' : item.name}}
          </template>
          <template slot-scope="scope">
            {{scope.row.list[index] && scope.row.list[index].material ? scope.row.list[index].material : '-'}}
          </template>
        </el-table-column>
        <el-table-column v-if="(tableData[0] && tableData[0].list)" fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="() => editMaterial(scope.row)">编辑</el-button>
            <el-button type="text" @click="() => deleteMaterial(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template slot="footer-right">
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </template>

    <!-- 添加/编辑材质对话框 -->
    <el-dialog :title="`${title}材质`" :visible.sync="dialogVisible" width="30%" :before-close="handleCloseDialog">
      <el-form ref="form" label-position="right" :model="form" :rules="rules" label-width="80px">
        <el-form-item v-for="(item, key) of form" :key="key" :label="key" :prop="key === '通用英语' ? '通用英语' : ''">
          <el-input v-model="form[key]" size="medium" :placeholder="`请输入${key}`" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleCloseDialog">取 消</el-button>
        <el-button size="medium" type="primary" @click="handleConfirmDialog">确 定</el-button>
      </span>
    </el-dialog>
  </page-skeleton>
</template>

<script>
import API from '@/api'
import PageSkeleton from './components/PageSkeleton.vue'

export default {
  name: 'supply_material',
  components: {
    'page-skeleton': PageSkeleton
  },
  data() {
    return {
      tableData: [], // 表格数据源

      parameter: {
        pageSize: 20, // 每页显示条数
        pageNumber: 1 // 当前页
      }, // 获取材质列表的请求参数
      total: 0, // 分页总数

      title: '添加', // 对话框表头
      dialogVisible: false, // 控制对话框的显示与隐藏
      form: {}, // 对话框中表单的绑定值
      languages: [], // 语言列表数据
      rules: { // 对话框中表单的验证对象
        '通用英语': [
          { required: true, message: '请输入通用英语的材质', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符之间', trigger: 'blur' }
        ]
      },

      editRow: {}, // 当前编辑的行
      editData: [] // 当前编辑行获取到的数据
    }
  },
  created() {
    this.getMaterialList()
  },
  methods: {
    // 材质列表
    async getMaterialList(call = true) {
      try {
        if (call) this.resetPage()
        let { data } = await API.getMaterialList(this.parameter)
        this.total = data.total
        this.tableData = data.list
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      } catch (error) {
        throw new Error(error.message)
      }
      this.$tableScrollTop()
    },
    resetPage() {
      this.parameter.pageNumber = 1
    },

    // 获取语言列表
    async getPublicSelectData() {
      let { data } = await API.getPublicSelectData({ type: 1, param: undefined })
      this.languages = data
      data.forEach((item) => {
        this.$set(this.form, item.name, undefined)
      })
    },

    // 添加材质
    addMaterial() {
      this.dialogVisible = true
      this.getPublicSelectData()
    },

    // 编辑材质
    async editMaterial(row) {
      this.editRow = row
      this.title = '编辑'
      this.dialogVisible = true
      await this.getPublicSelectData()
      let { data } = await API.editMateria(row.materialId)
      this.editData = data
      data.forEach((item) => {
        Object.keys(this.form).forEach((key) => {
          if (key === item.languageName) {
            this.form[key] = item.material
          }
        })
      })
    },

    // 删除材质
    deleteMaterial(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let result = await API.deleteMateria(row.materialId)
        if (result.code === 10000) {
          this.$message.success(result.message)
          this.getMaterialList()
        } else {
          this.$message.error(result.message)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },

    // 每页显示条数发生改变时的回调
    handleSizeChange(size) {
      this.parameter.pageSize = size
      this.getMaterialList(false)
    },

    // 上一页/下一页/当前页发生改变时的回调
    handleCurrentChange(current) {
      this.parameter.pageNumber = current
      this.getMaterialList(false)
    },

    // 对话框关闭的回调
    handleCloseDialog() {
      this.form = {}
      this.editRow = {}
      this.editData = []
      this.dialogVisible = false
      this.$refs.form.resetFields()
    },

    // 对话框确认的回调
    handleConfirmDialog() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        let arr = []
        if (this.title === '添加') {
          Object.keys(this.form).forEach((key, index) => {
            if (this.languages[index].name === key && this.form[key]) {
              arr.push({
                languageId: this.languages[index].code,
                material: this.form[key]
              })
            } else {
              arr.push({
                languageId: this.languages[index].code,
                material: ''
              })
            }
          })
          let result = await API.addMateria(arr)
          if (result.code === 10000) {
            this.$message.success(result.message)
            this.handleCloseDialog()
            this.getMaterialList(false)
          } else {
            this.$message.error(result.message)
          }
        } else if (this.title === '编辑') {
          Object.keys(this.form).forEach((key, index) => {
            if (this.languages[index].name === key && this.form[key] && this.editData[index].languageName === key) {
              arr.push({
                id: this.editData[index].id,
                languageId: this.editData[index].languageId,
                material: this.form[key]
              })
            } else {
              arr.push({
                id: this.editData[index].id,
                languageId: this.editData[index].languageId,
                material: ''
              })
            }
          })
          let result = await API.confirmEditMateria(arr)
          if (result.code === 10000) {
            this.$message.success(result.message)
            this.handleCloseDialog()
            this.getMaterialList(false)
          } else {
            this.$message.error(result.message)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  height: 500px;
  overflow: auto;
}
</style>